import { render, staticRenderFns } from "./ContentBlockToggle.vue?vue&type=template&id=0c3c2535&"
import script from "./ContentBlockToggle.vue?vue&type=script&lang=js&"
export * from "./ContentBlockToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports